export const frontmatter = {
    "draft": true,
    "title": "Claves API",
    "description": "Gestión de claves API en OnnIA.",
    "sidebar_label": "Claves API",
    "sidebar_group": "referencia",
    "sidebar_order": 6
}

export const toc = []